module.exports = __webpack_public_path__ + "static/img/tiggi_profile_800x686.83192fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tiggi_profile_800x686.jpg
// module id = MJpW
// module chunks = 0